module.exports = __webpack_public_path__ + "static/img/159851923.f1c02b69.png";